import ordersIcon from '~assets/ic_orders.png';
import ordersIconSelected from '~assets/ic_orders_selected.png';
import inProgressIcon from '~assets/ic_inProgress.png';
import inProgressIconSelected from '~assets/ic_inProgress_selected.png';
import historyIcon from '~assets/ic_history.png';
import historyIconSelected from '~assets/ic_history_selected.png';
import readyIcon from '~assets/ic_ready.png';
import readyIconSelected from '~assets/ic_ready_selected.png';
import blockedIcon from '~assets/ic_blocked.png';
import blockedIconSelected from '~assets/ic_blocked_selected.png';
import scheduledIcon from '~assets/ic_scheduled.png';
import scheduledIconSelected from '~assets/ic_scheduled_selected.png';
import rejectedIcon from '~assets/ic_rejected.png';
import rejectedIconSelected from '~assets/ic_rejected_selected.png';
import orderTakerIcon from '~assets/ic_order_taker.png';
import orderTakerSelectedIcon from '~assets/ic_order_taker_selected.png';
import { POLICY_ACTIONS, POLICY_PATHS } from '~constants/policies';
import { ORDER_STATUS } from '~constants/orders';
import { isRejectedOrderManagerEnabled } from '~constants/features';
import isOrderTakerEnabled from '~utils/orderTaker';

// Función para obtener los sidebar items basándose en el tenant
export const getSidebarItemsForTenant = (tenant) => {
  const baseItems = {
    CREATED: {
      status: [ORDER_STATUS.CREATED],
      policy: POLICY_PATHS.ORDERS,
      order: 2,
      showQuantityOrders: true,
      actions: [POLICY_ACTIONS.UPDATE]
    },
    PREPARING: {
      status: [ORDER_STATUS.PREPARING],
      policy: POLICY_PATHS.ORDERS,
      order: 3,
      showQuantityOrders: true,
      actions: [POLICY_ACTIONS.UPDATE]
    },
    READY: {
      status: [ORDER_STATUS.READY, ORDER_STATUS.IN_TRANSIT],
      policy: POLICY_PATHS.ORDERS,
      order: 4,
      showQuantityOrders: true,
      actions: [POLICY_ACTIONS.UPDATE]
    },
    HISTORY: {
      status: [ORDER_STATUS.CANCELED, ORDER_STATUS.COMPLETED],
      policy: POLICY_PATHS.ORDERS,
      order: 5,
      showQuantityOrders: false,
      actions: [POLICY_ACTIONS.UPDATE]
    },
    PRODUCTS: {
      status: [ORDER_STATUS.PRODUCTS],
      policy: POLICY_PATHS.DISABLEDS,
      order: 6,
      showQuantityOrders: false,
      actions: [POLICY_ACTIONS.UPDATE]
    },
    SCHEDULED: {
      status: [ORDER_STATUS.SCHEDULED],
      policy: POLICY_PATHS.ORDERS,
      order: 1,
      showQuantityOrders: true,
      actions: [POLICY_ACTIONS.UPDATE]
    }
  };

  // Solo agregar ORDER_TAKER si el tenant está habilitado
  if (isOrderTakerEnabled(tenant)) {
    baseItems.ORDER_TAKER = {
      status: [ORDER_STATUS.ORDER_TAKER],
      policy: POLICY_PATHS.ORDERS,
      order: 8,
      showQuantityOrders: false,
      actions: [POLICY_ACTIONS.UPDATE]
    };
  }

  if (isRejectedOrderManagerEnabled) {
    baseItems.REJECTED_ORDER_MANAGER = {
      status: [ORDER_STATUS.REJECTED_ORDER_MANAGER],
      policy: POLICY_PATHS.REJECTED_ORDERS,
      order: 7,
      showQuantityOrders: false,
      flag: isRejectedOrderManagerEnabled,
      actions: [POLICY_ACTIONS.ASSIGN_USER, POLICY_ACTIONS.ASSIGN_EXTERNAL_ID, POLICY_ACTIONS.INDEX]
    };
  }

  return baseItems;
};

// Función para obtener los sidebar items desde el estado de Redux
export const getSidebarItemsFromState = (state) => {
  const tenant = state.core.tenant;
  return getSidebarItemsForTenant(tenant);
};

export const SIDEBAR_ITEMS = {
  CREATED: {
    status: [ORDER_STATUS.CREATED],
    policy: POLICY_PATHS.ORDERS,
    order: 2,
    showQuantityOrders: true,
    actions: [POLICY_ACTIONS.UPDATE]
  },
  PREPARING: {
    status: [ORDER_STATUS.PREPARING],
    policy: POLICY_PATHS.ORDERS,
    order: 3,
    showQuantityOrders: true,
    actions: [POLICY_ACTIONS.UPDATE]
  },
  READY: {
    status: [ORDER_STATUS.READY, ORDER_STATUS.IN_TRANSIT],
    policy: POLICY_PATHS.ORDERS,
    order: 4,
    showQuantityOrders: true,
    actions: [POLICY_ACTIONS.UPDATE]
  },
  HISTORY: {
    status: [ORDER_STATUS.CANCELED, ORDER_STATUS.COMPLETED],
    policy: POLICY_PATHS.ORDERS,
    order: 5,
    showQuantityOrders: false,
    actions: [POLICY_ACTIONS.UPDATE]
  },
  PRODUCTS: {
    status: [ORDER_STATUS.PRODUCTS],
    policy: POLICY_PATHS.DISABLEDS,
    order: 6,
    showQuantityOrders: false,
    actions: [POLICY_ACTIONS.UPDATE]
  },
  SCHEDULED: {
    status: [ORDER_STATUS.SCHEDULED],
    policy: POLICY_PATHS.ORDERS,
    order: 1,
    showQuantityOrders: true,
    actions: [POLICY_ACTIONS.UPDATE]
  }
};

if (isRejectedOrderManagerEnabled) {
  SIDEBAR_ITEMS.REJECTED_ORDER_MANAGER = {
    status: [ORDER_STATUS.REJECTED_ORDER_MANAGER],
    policy: POLICY_PATHS.REJECTED_ORDERS,
    order: 7,
    showQuantityOrders: false,
    flag: isRejectedOrderManagerEnabled,
    actions: [POLICY_ACTIONS.ASSIGN_USER, POLICY_ACTIONS.ASSIGN_EXTERNAL_ID, POLICY_ACTIONS.INDEX]
  };
}

export const SIDEBAR_ITEMS_ICONS = {
  [ORDER_STATUS.CREATED]: {
    selected: ordersIconSelected,
    disabled: ordersIcon
  },
  [ORDER_STATUS.PREPARING]: {
    selected: inProgressIconSelected,
    disabled: inProgressIcon
  },
  [ORDER_STATUS.READY]: {
    selected: readyIconSelected,
    disabled: readyIcon
  },
  [ORDER_STATUS.CANCELED]: {
    selected: historyIconSelected,
    disabled: historyIcon
  },
  [ORDER_STATUS.PRODUCTS]: {
    selected: blockedIconSelected,
    disabled: blockedIcon
  },
  [ORDER_STATUS.SCHEDULED]: {
    selected: scheduledIconSelected,
    disabled: scheduledIcon
  },
  [ORDER_STATUS.REJECTED_ORDER_MANAGER]: {
    selected: rejectedIconSelected,
    disabled: rejectedIcon
  },
  [ORDER_STATUS.ORDER_TAKER]: {
    selected: orderTakerSelectedIcon,
    disabled: orderTakerIcon
  }
};

export const DEFAULT_ITEM = 'CREATED';
export const PREPARING = 'PREPARING';
